export default "__VITE_ASSET__ChRh5IRf__"